<div [formGroup]="form" class="form">
  <div class="loan">

    <div>
      <mat-form-field [style.width.px]="housingLoan() ? 120 : 265">
        <mat-label>Typ av lån</mat-label>
        <mat-select formControlName="loanType">
          @for (type of loanTypes; track type.type) {
            <mat-option
              [value]="type.type">{{ type.title }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field [style.width.px]="130">
        <mat-label>Belopp</mat-label>
        <input
          formControlName="amount"
          matInput
          name="loanAmount"
          spbFormatNumber>
        <span matTextSuffix="">kr</span>
      </mat-form-field>
    </div>

    @if (housingLoan()) {
      <mat-checkbox
        formControlName="additionalLoan">Alternativregellån
      </mat-checkbox>
    }

    <!--    I have temporarily deactivated these because they are not needed at the moment.-->
    @if (!housingLoan() && false) {
      <div>
        <mat-form-field [style.width.px]="130">
          <mat-label>Amortering</mat-label>
          <input
            formControlName="mortgage"
            matInput
            spbFormatNumber
          >
          <span matTextSuffix="">kr/mån</span>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field [style.width.px]="75">
          <mat-label>Ränta</mat-label>
          <input
            class="spb-flipper"
            formControlName="interestPercentString"
            matInput
            type="number">
          <span matTextSuffix="">%</span>
        </mat-form-field>
      </div>
    }
    @if (properties().length > 0 && form.controls.loanType.value === 'MORTGAGE') {
      <div>
        <mat-form-field
          [style.width.px]="250">
          <mat-label>Välj boende</mat-label>
          <mat-select formControlName="propertyId">
            @for (property of (propertySelect$ | async); track property.id) {
              <mat-option [value]="property.id">{{ property.friendlyName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    @if (form.controls.showExtraSettings.value) {
      <ng-container>

        <div>
          <mat-checkbox formControlName="solve">Löses</mat-checkbox>
        </div>

        <div>
          <mat-form-field [style.width.px]="175">
            <mat-label>Räntebindning</mat-label>
            <mat-select (selectionChange)="changeTerm($event.value)"
                        formControlName="terms">
              @for (term of filteredTerms; track term.terms) {
                <mat-option [value]="term.terms">{{ term.text }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field [style.width.px]="175">
            <mat-label>Villkorsändringsdag</mat-label>
            <input [matDatepicker]="picker" formControlName="expires" matInput>
            <mat-datepicker-toggle [for]="picker"
                                   matIconSuffix></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </ng-container>
    }
    <div class="delete-button">
      <button (click)="removeLoan()(index())" mat-icon-button>
        <mat-icon class="negative">delete</mat-icon>
      </button>
    </div>
  </div>
</div>
